export enum ActionTypes {
	HANDLE_CHANGE_FORM_STEP = "HANDLE_CHANGE_FORM_STEP",
}

export type Action = {
	type: ActionTypes.HANDLE_CHANGE_FORM_STEP;
	payload: { currentStep: number };
};

export type State = {
	currentStep: number;
};

export type Dispatch = (action: Action) => void;

export type CreateCoursesProviderProps = { children: React.ReactNode };
